module.exports = __webpack_public_path__ + "static/media/PerkIcons2.4252528e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PerkIcons2.png
// module id = 91
// module chunks = 0